import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import getMapData from "../shared/services/mapPositions.data.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_POSITIONS = "REQUEST_MAP_POSITIONS";
const RESPONSE_MAP_POSITIONS = "RESPONSE_MAP_POSITIONS";
const REQUEST_MAP_POSITIONS_FAILURE = "REQUEST_MAP_POSITIONS_FAILURE";
const CLEAR_MAP_POSITIONS = "CLEAR_MAP_POSITIONS";

const requestMapPositionsAction = () => {
  return {
    type: REQUEST_MAP_POSITIONS,
  };
};

const responseMapPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_POSITIONS,
    payload: data,
  };
};

const requestMapPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_POSITIONS_FAILURE,
    errors,
  };
};

const getMapPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapPositionsAction());

    intellegenceService
      .getMapPositions(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        let data = null;
      
        try {
          data = getMapData(result.data);
        } catch (error) {
          console.error("!!!!!An error occurred:", error);
        } 

        dispatch(responseMapPositionsAction(data));
      })
      .catch((error) => {
        dispatch(requestMapPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapPositionsAction = () => {
  return {
    type: CLEAR_MAP_POSITIONS,
  };
};

export {
  REQUEST_MAP_POSITIONS,
  RESPONSE_MAP_POSITIONS,
  REQUEST_MAP_POSITIONS_FAILURE,
  CLEAR_MAP_POSITIONS,
  requestMapPositionsAction,
  responseMapPositionsAction,
  requestMapPositionsFailureAction,
  getMapPositions,
  clearMapPositionsAction,
};
